export const ENTRY_SYSTEM = 'ENTRY_SYSTEM';

export const LOG_IN_HEADER = 'LOG_IN_HEADER';
export const LOG_IN_BUTTON = 'LOG_IN_BUTTON';

export const HOME_KSM_LEARN_MORE = 'HOME_KSM_LEARN_MORE';
export const HOME_KCT_LEARN_MORE = 'HOME_KCT_LEARN_MORE';
export const HOME_RANK_LEARN_MORE = 'HOME_RANK_LEARN_MORE';

export const KCC_INSPIRATION_AD = 'KCC_INSPIRATION_AD';
export const KCC_INSPIRATION_VIDEO = 'KCC_INSPIRATION_VIDEO';
export const KCC_INSPIRATION_STRATEGIE = 'KCC_INSPIRATION_STRATEGIE';
export const KCC_TREND_HASHTAG = 'KCC_TREND_HASHTAG';
export const KCC_TREND_SONG = 'KCC_TREND_SONG';
export const KCC_TREND_CREATOR = 'KCC_TREND_CREATOR';
export const KCC_CREATIVE_TOOLS = 'KCC_CREATIVE_TOOLS';
export const KCC_PURCHASE_OF_CREATIVES = 'KCC_PURCHASE_OF_CREATIVES';

export const KCC_INSPIRATION_AD_AREA = 'KCC_INSPIRATION_AD_AREA';
export const KCC_INSPIRATION_AD_INDUSTRY = 'KCC_INSPIRATION_AD_INDUSTRY';
export const KCC_INSPIRATION_AD_CAMPAIGN = 'KCC_INSPIRATION_AD_CAMPAIGN';
export const KCC_INSPIRATION_AD_PERIOD = 'KCC_INSPIRATION_AD_PERIOD';
export const KCC_INSPIRATION_AD_LOAD_MORE = 'KCC_INSPIRATION_AD_LOAD_MORE';
